<template>
    <b-container fluid>
        <vue-toastr ref="toastr" />
        <div :class="{blur: loading}">
            <b-row>
                <b-col>
                    <h1 class="mb-4">Депозиты</h1>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="8">
                    <b-card title="Проценты по депозитам">
                        <b-row>
                            <b-col v-for="currencyCode in ['EUR', 'SPD']" :key="currencyCode">
                                <table class="table table-striped">
                                    <thead>
                                    <tr>
                                        <th>Валюта</th>
                                        <th>Сумма</th>
                                        <th class="text-center">%</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(depositType, index) in depositTypes[currencyCode]">
                                        <td :rowspan="depositTypes[currencyCode].length" class="text-center align-middle font-weight-bold table-warning" v-if="index == 0">{{depositType.currency }}</td>
                                        <td v-if="index == 0" class="small">До <span v-html="formatMoney(depositTypes[currencyCode][index+1].minimalAmount, depositType.currency, 0)"></span></td>
                                        <td v-else-if="index == depositTypes[currencyCode].length - 1" class="small">Свыше <span v-html="formatMoney(depositType.minimalAmount, depositType.currency, 0)"></span></td>
                                        <td v-else class="small">От <span v-html="formatMoney(depositType.minimalAmount, depositType.currency, 0)"></span><br>до <span v-html="formatMoney(depositTypes[currencyCode][index+1].minimalAmount, depositType.currency, 0)"></span></td>
                                        <td class="text-center font-weight-bold">{{ depositType.interest }}%</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>
                <b-col cols="4">
                    <b-card title="Открыть депозит">
                        <b-form @submit.prevent="openDeposit()">
                            <b-form-row>
                                <b-col cols="8">
                                    <b-form-group label="Сумма вклада" label-for="deposit-amount">
                                        <b-form-input id="deposit-amount" v-model.number="deposit.amount" :formatter="onlyDigits" type="number" />
                                    </b-form-group>
                                </b-col>
                                <b-col cols="4">
                                    <b-form-group label="Валюта" label-for="deposit-currency">
                                        <b-form-select id="deposit-currency" v-model="deposit.currency" :options="currencies" />
                                    </b-form-group>
                                </b-col>
                            </b-form-row>
                            <p v-if="isSPDSelected" class="small text-danger"><b>Внимание!</b> Открытие депозита в SPD осуществляется только при прямой покупке SPD у Банка.</p>
                            <b-button type="submit" variant="primary">
                                <i class="fa fa-shopping-cart"></i> &nbsp;Открыть
                            </b-button>
                            <h6 class="mt-5">Рассчет</h6>
                            <b-form-row>
                                <b-col cols="8">
                                    <b-form-group label="Срок" label-for="deposit-time">
                                        <b-form-select id="form-time" v-model="deposit.period" :options="periods" />
                                    </b-form-group>
                                </b-col>
                                <b-col cols="4">
                                    <b-form-group label="Процент" label-for="deposit-interest">
                                        <b-form-input id="deposit-interest" :value="interest" readonly />
                                    </b-form-group>
                                </b-col>
                            </b-form-row>

                            <p>Итого: <span v-html="formatMoney(totalAmount, deposit.currency)"></span></p>
                        </b-form>
                    </b-card>
                </b-col>
            </b-row>
            <b-row v-if="hasDepositOrders">
                <b-col cols="8">
                    <b-card title="Мои депозиты">
                        <b-table stripped hover :items="depositOrders" :fields="depositOrdersFields">
                            <template slot="amount" scope="row">
                                <span v-html="formatMoney(row.item.amount, row.item.currency)"></span>
                            </template>
                            <template slot="period" scope="row">
                                <span v-html="periodTitle(row.item.period)"></span>
                            </template>
                            <template slot="total" scope="row">
                                <span v-html="formatMoney(calculateTotalAmount(row.item.amount, row.item.interest), row.item.currency)"></span>
                            </template>
                            <template slot="paid" scope="row">
                                <b-button v-if="!row.item.paid" size="sm" variant="primary" @click.prevent="paymentOrderId = row.item.id" v-b-modal.paymentSystems>
                                    <i class="fa fa-check"></i> Оплатить
                                </b-button>
                                <template v-else>{{ row.item.paid }}</template>
                            </template>
                        </b-table>
                    </b-card>
                </b-col>
            </b-row>
        </div>
        <div v-if="loading" class="loading-container">
            <data-loading></data-loading>
        </div>
        <modal-payment :order-id="paymentOrderId" />
    </b-container>
</template>

<script>
    import DataLoading from '@/containers/DataLoading.vue'
    import Toastr from 'vue-toastr'
    import Payment from '@/components/Payment.vue'

    export default {
        name: 'deposits',
        components: {
            'data-loading': DataLoading,
            'vue-toastr': Toastr,
            'modal-payment': Payment
        },
        data () {
            return {
                loading: false,
                deposit: {
                    amount: 200,
                    currency: 'EUR',
                    period: 3
                },
                currencies: [{
                    value: 'SPD',
                    text: 'SPD'
                }, {
                    value: 'EUR',
                    text: 'EUR'
                }],
                periods: [{
                    value: 1,
                    text: '1 месяц'
                }, {
                    value: 3,
                    text: '3 месяца'
                }, {
                    value: 6,
                    text: '6 месяцев'
                }, {
                    value: 9,
                    text: '9 месяцев'
                }, {
                    value: 12,
                    text: '1 год'
                }],
                depositTypes: {
                    'EUR': [],
                    'SPD': []
                },

                depositOrders: [],
                depositOrdersFields: {
                    amount: {
                        label: 'Сумма',
                        tdClass: 'small'
                    },
                    interest: {
                        label: '%',
                        tdClass: 'small'
                    },
                    total: {
                        label: 'Вознаграждение за месяц',
                        tdClass: 'small'
                    },
                    date: {
                        label: 'Дата заказа',
                        // thClass: 'small',
                        tdClass: 'small'
                    },
                    paid: {
                        label: '',
                        // thClass: 'small',
                        tdClass: 'small',
                        formatter: (value) => {
                            if (value) {
                                return value
                            }
                            return ''
                        }
                    }
                },

                paymentOrderId: null
            }
        },
        computed: {
            interest () {
                let result
                this.depositTypes[this.deposit.currency].forEach((depositType) => {
                    if (this.deposit.currency === depositType['currency'] && this.deposit.amount >= depositType['minimalAmount']) {
                        result = result ? ((result < depositType.interest) ? depositType.interest : result) : depositType.interest
                    }
                })

                return result
            },
            isSPDSelected () {
                return this.deposit.currency === 'SPD'
            },
            totalAmount () {
                let total = this.deposit.amount * this.interest / 100

                return (this.deposit.amount + ((total / 12) * this.deposit.period)).toFixed(2)
            },
            hasDepositOrders () {
                return (this.depositOrders.length > 0)
            }
        },
        mounted () {
            this.loadDepositsData()
            this.loadDepositOrders()
        },
        methods: {
            onlyDigits (value, event) {
                if (isNaN(parseInt(event.data)) || event.data === '.' || event.data === '') {
                    // value = value.substring(0, value.length - 1)
                }
                return value
            },
            periodTitle (period) {
                let result

                result = this.periods.filter(item => {
                    return (item.value === period)
                })

                if (result.length === 0) {
                    result = 0
                } else {
                    result = result[0]['text']
                }

                return result
            },
            formatMoney (num, currency, c, d, t) {
                let n = num
                c = isNaN(c = Math.abs(c)) ? 2 : c
                d = d === undefined ? '.' : d
                t = t === undefined ? '&nbsp;' : t
                let s = n < 0 ? '-' : ''
                let i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c)))
                let j = i.length
                j = (j) > 3 ? j % 3 : 0
                return (s + (j ? i.substr(0, j) + t : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : '')) + '&nbsp;<small>' + currency + '</small>'
            },
            loadDepositOrders () {
                this.loading = true
                this.axios.get('deposits/orders')
                    .then(response => {
                        this.depositOrders = response.data['orders']

                        if (response.data.hasOwnProperty('message') && response.data['message']) {
                            this.$refs['toastr'].i(response.data['message'])
                        }

                        setTimeout(() => {
                            this.loading = false
                        }, 500)
                    })
                    .catch(() => {
                        this.$refs['toastr'].e('Произошла ошибка')
                        this.loading = false
                    })
            },
            openDeposit () {
                if (this.deposit.currency === 'SPD') {
                    this.$refs['toastr'].w('Открытие депозитов в SPD приостановлено на время осуществления ICO')
                    return
                }
                this.loading = true

                this.axios.post('deposits/open', this.deposit)
                    .then(response => {
                        this.depositOrders.unshift(response.data['order'])

                        if (response.data.hasOwnProperty('message') && response.data['message']) {
                            this.$refs['toastr'].i(response.data['message'])
                        }

                        setTimeout(() => {
                            this.loading = false
                        }, 500)
                    })
                    .catch(() => {
                        this.$refs['toastr'].e('Произошла ошибка')
                        setTimeout(() => {
                            this.loading = false
                        }, 500)
                    })
            },
            loadDepositsData () {
                this.loading = true

                this.axios.get('deposits/types')
                    .then(response => {
                        this.depositTypes = response.data['depositTypes']

                        if (response.data.hasOwnProperty('message') && response.data['message']) {
                            this.$refs['toastr'].i(response.data['message'])
                        }

                        setTimeout(() => {
                            this.loading = false
                        }, 500)
                    })
                    .catch(() => {
                        this.$refs['toastr'].e('Произошла ошибка')
                    })
            },
            calculateTotalAmount (amount, interest) {
                let total = amount * interest / 100

                return ((total / 12)).toFixed(2)
            },
            payOrder (orderId) {
                let message = 'Нет доступных систем оплаты.'
                this.$refs['toastr'].e(message)
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Deposits.vue?1ef576ca